//
// Module for the Age Rate Tables Edit view
//
rs.module("content/system_/configuration/ageratetables/edit",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, columnIds, lrsGridApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var addTableDetailButton = criteria.js(jsSelectors.addTableDetailButton, { required: false });
            var detailUpdateToken = criteria.js(jsSelectors.detailUpdateToken, { required: false });
            var ageRateDetailKey = criteria.js(jsSelectors.ageRateDetailKey, { required: false });
            var ageRateDetailAgeInput = criteria.js(jsSelectors.ageRateDetailAgeInput, { required: false });
            var ageRateDetailRatePercentInput = criteria.js(jsSelectors.ageRateDetailRatePercentInput, { required: false });
            var cancelTableDetailButton = criteria.js(jsSelectors.cancelTableDetailButton, { required: false });

            if (lrsGridApi) {

                // On load, if a row is selected - scroll to ensure it is visible.
                if (lrsGridApi.agGridApi.getSelectedNodes().length != 0) {
                    var firstSelectedRowIndex = lrsGridApi.agGridApi.getSelectedNodes()[0].rowIndex;
                    lrsGridApi.agGridApi.ensureIndexVisible(firstSelectedRowIndex, 'middle');
                }

                // On add button click, clear the form
                addTableDetailButton.click(function () {

                    eventBanner.removeAllMessages();
                    lrsGridApi.selectedValues = null;

                    // Reset inputs
                    [
                        detailUpdateToken,
                        ageRateDetailKey,
                        ageRateDetailAgeInput,
                        ageRateDetailRatePercentInput
                    ].forEach((input) => input.clearErrors().val(''));
                    ageRateDetailKey.val(-1);
                });

                // On cancel button click, select first entry and clear event banner.
                cancelTableDetailButton.click(function () {

                    // Reset inputs
                    [
                        detailUpdateToken,
                        ageRateDetailKey,
                        ageRateDetailAgeInput,
                        ageRateDetailRatePercentInput
                    ].forEach((input) => input.clearErrors().val(''));
                    ageRateDetailKey.val(-1);

                    lrsGridApi.selectedValues = null;
                    lrsGridApi.selectFirstRow();
                    eventBanner.removeAllMessages();
                });

                // Listen for row selection 
                lrsGridApi.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        $.getJSON(backendUrl, { ageRateDetailKey: rows[0][columnIds.ageRateDetailKey] }).done(function (data) {

                            // Hidden Token
                            detailUpdateToken.val(data.updateToken);
                            ageRateDetailKey.val(data.ageRateDetailKey);

                            // Update Fields
                            ageRateDetailAgeInput.val(data.age);
                            ageRateDetailRatePercentInput.val(data.ratePercent);

                            [
                                ageRateDetailAgeInput,
                                ageRateDetailRatePercentInput
                            ].forEach((input) => input.clearErrors());
                            eventBanner.removeAllMessages();   
                        });
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);